/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Plan_TitleInputs */

const en_features_plan_title = /** @type {(inputs: Features_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write it once. Your client has it on their phone.`)
};

const pl_features_plan_title = /** @type {(inputs: Features_Plan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piszesz raz. Klient ma to w telefonie.`)
};

/**
* | output |
* | --- |
* | "Write it once. Your client has it on their phone." |
*
* @param {Features_Plan_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_plan_title = /** @type {((inputs?: Features_Plan_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Plan_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_plan_title(inputs)
	return en_features_plan_title(inputs)
});